export default {
  business: {
    businessName: '',
    businessAddress: '',
    businessTel: ''
  },
  jobAddress: {
    jobName: '',
    jobAddress: '',
    jobTel: '',
    accommodationRented: ''
  },
  landlordAgent: {
    landlordName: '',
    landlordAddress: '',
    landlordTel: ''
  },
  heatPumpDetails: {
    unitMake: '',
    unitModel: '',
    serialNumber: '',
    mcsCertificationNumber: '',
    installationDate: '',
    lastServiceDate: ''
  },
  heatPumpInspection: {
    physicalDamage: '',
    unitFreeOfLeaves: '',
    airFiltersCleaned: '',
    evaporatorCoilsInspected: '',
    insulationIntact: '',
    electricalConnectionsSecure: '',
    condensateDrainCleared: '',
    fanBladesSmoothRunning: '',
    refrigerantLevelsAdhere: '',
    controllerInspected: '',
    defrostSensorTested: '',
    temperatureDifferenceMeasured: '',
    waterPressureInRange: '',
    unitCheckedNoiseVibration: ''
  },
  hotWaterCylinderDetails: {
    cylinderMake: '',
    cylinderModel: '',
    cylinderSerialNumber: '',
    cylinderCapacity: '',
    cylinderInstallationDate: '',
    cylinderLastServiceDate: ''
  },
  cylinderInspection: {
    cylinderPipeworkNoLeaks: '',
    pressureReliefValveFunctioning: '',
    temperaturePressureWithinLimits: '',
    expansionVesselWithinSpecs: '',
    heatExchangerClean: '',
    insulationJacketGood: '',
    anodeFreeCorrosion: '',
    thermostatControllingTemp: '',
    noErrorCodes: '',
    cylinderDeliveringCorrectTemp: ''
  },
  defects: {
    defectsIdentified: ''
  },
  workCarriedOut: {
    workCarriedOut: ''
  },
  workRequired: {
    workRequired: ''
  },
  receivedBy: {
    receivedByName: '',
    receivedByDate: ''
  },
  issuedBy: {
    engineerSignature: '',
    issuedByDate: ''
  },
  nextService: {
    nextServiceDate: ''
  }
};
